import React from "react";
import { Link} from 'react-router-dom';
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import VideoCourseImage from "../assets/images/video-course.jpg";
import VideoTestimonial from "../components/Frontend/VideoPTETestimonial";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import API from "../api";
import { store } from "store/index";
import { setAlert } from "action/index";
import { getCountryForTimezone } from "countries-and-timezones";
import BuyBtn from "components/VideoCourse/BuyBtn";
import Plans from "components/VideoCourse/Plans";
import Slider from "react-slick";

class VideoCourse extends React.Component {
  constructor(props) {
    super(props);
    this.sectionRef = React.createRef();
    this.state = {
      plans: [],
      corePlans: [],
      country: "AU",
      activeTab: "la_acedemics_tab",
      homePage: false,
      list: [],
      sliderStyles: { marginLeft: "0px", width: "100%" },
    };
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.adjustSliderWidth);
  }
  adjustSliderWidth = () => {
    const container = document.querySelector(".container");
    const outerDiv = document.querySelector(".outer-wrapper");
    const slickList = document.querySelector(".slick-list");
    if (container && outerDiv && slickList) {
      const leftWidth = container.getBoundingClientRect().left;
      const rightWidth =
        outerDiv.getBoundingClientRect().right - window.innerWidth;
      this.setState({
        sliderStyles: {
          marginLeft: `${leftWidth}px`,
          width: `calc(100vw - ${leftWidth}px + ${Math.abs(rightWidth)}px)`,
        },
      });
    }
  };



  handleTabClick = (tab) => {
    this.setState({ activeTab: tab });
  };

  scrollToSection = () => {
    const section = this.sectionRef.current;
    if (section) {
      const headerHeight = document.querySelector("header").offsetHeight || 0;
      const sectionTop = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionTop - headerHeight,
        behavior: "smooth",
      });
    }
  };

  componentDidMount() {
    this.adjustSliderWidth();
    window.addEventListener("resize", this.adjustSliderWidth);   
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
    if (window.location.href.indexOf("#packages") != -1) {
      window.location.hash = "";
      window.location.hash = "packages";
    }
    this.getPackages();
  }

  getPackages() {
    const country = getCountryForTimezone(
      Intl.DateTimeFormat().resolvedOptions().timeZone
    );
    let countryId = "AU";
    if (country && country.id) {
      countryId = country.id;
    }
    const url =
      import.meta.env.VITE_URL_ALT +
      "/api/v2/getPackagesAll?countryId=" +
      countryId;
    API({
      url: url,
      method: "GET",
    }).then((res) => {
      if (res.status === 200) {
        const data = res.data;
        const laPlans = data.la.filter((plan) => plan.is_video !== 0);
        const corePlans = data.core.filter((plan) => plan.is_video !== 0);
        this.setState({ plans: laPlans, corePlans, country: res.data.country });
      } else {
        store.dispatch(
          setAlert({ flag: true, type: 2, message: "Something went wrong." })
        );
      }
    });
  }  

  render() {
    const settings = {
      slidesToShow: 3.5,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: true,
      dots: true,
      centerMode: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2.5,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.5,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };
    return (
      <React.Fragment>
        <Helmet>
          <title>Language Academy</title>
        </Helmet>
        <Header />
        <div className="innerPage">
          <div className="new-video-course mt-80">
            <div className="container">
              <div className="row align-items-center position-relative">
                {/* <img
                  className="emoji-img emoji1"
                  src="/images/web-new-images/emojis/22.png"
                  alt="LA"
                />
                <img
                  className="emoji-img emoji2"
                  src="/images/web-new-images/emojis/4.png"
                  alt="LA"
                /> */}
                <div className="col-lg-7">
                  <h2 className="mfw-600 primary-heading dark-blue-color text-center text-lg-start">Master PTE <br className="d-none d-md-block" /> with Our Exclusive <br className="d-none d-md-block" /> Video Course</h2>   
                  <p className="sub-title text-center text-lg-start">Carve your skills with our PTE Core Exam Online Training to excel in the English test for Canada. Our expert coaching and personalized study strategies, using the latest PTE Core Test Practice Material, will help you achieve success.</p> 
                  <div className="text-center text-lg-start">                   
                    <Link to="/auth/register" className="primary-btn light-border">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" /></Link>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="video-course-content">
                    <div className="video-wrapper">
                    <iframe
                          src="https://player.vimeo.com/video/984725169?h=e48ced1845&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                          frameBorder="0"
                          width="100%"
                          allow="fullscreen;"
                          allowFullScreen
                        ></iframe>
                      </div>
                      <p className="normal-text text-center text-lg-start">
                        Developed by{" "}
                        <span className="fw-semibold">Varun Dhawan</span>, an
                        esteemed educator and a 14-time scorer of perfect 90 in
                        PTE Academic, this course is designed to equip you with
                        the skills needed to excel in
                      </p>
                      <div className="gradient-box d-inline-block rounded-pill text-center text-lg-start">
                      <ul className="why-choosing-list m-0 rounded-24 rounded-pill">
                        <li className="speaking">Speaking</li>
                        <li className="listening">Listening</li>
                        <li className="reading">Reading</li>
                        <li className="writing">Writing</li>
                      </ul>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="score-earners-section">
            <div className="container">
              <div className="col-md-12">
                <h2 className="primary-heading text-center">Top <br className="d-block" /> <span className="wpl-badge pte-naati-badge text-white">PTE Scorecard</span> <br className="d-block" /> Earners</h2>
                <div className="score-earners-content">
                  <div className="info-card">
                    <div className="user-info-outer">
                        <div className="user-info">
                          <h3>Varun <br /> Dhawan</h3>
                          <p className="normal-text">
                            <strong>Position</strong> Language Academy Tutor
                          </p>
                        </div>                
                    </div>
                    <div className="user-img-wrapper"> 
                      <img
                      className="d-none d-md-block"
                        src="/images/web-new-images/person-img.png"
                        alt="LA"
                      />
                      <img
                        className="d-block d-md-none"
                        src="/images/web-new-images/person-mobile-img.png"
                        alt="LA"
                      />
                    </div>
                  </div>
                  <div className="user-bio">
                    <p className="normal-text">
                      <strong className="text-start">Profile Bio</strong>
                      Vivamus sagittis bibendum vulputate. Suspendisse lacus nibh, blandit ac tortor eu, dapibus accumsan ligula. Nam eu metus non nunc laoreet placerat et sit amet dui. Integer tempus ligula ante. Pellentesque a sapien ac odio mollis gravida. Ut vel magna nec nunc aliquet malesuada nec ut urna.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="outer-wrapper m-0 overflow-hidden">
            <div className="la-student-section score-slider slider-dot-arrow green-dots">
                  <div className="container">                
                  </div>
                  <div className="slider" ref={this.sliderRef} style={this.state.sliderStyles}>
                    <Slider
                    {...settings}
                    className="student-review student-images-slider"
                  >
                    <div>
                      <div className="score-slider-card">
                        <div className="img-wrapper">
                          <img
                            className="img-fluid"
                            src="/images/web-new-images/pte3.jpeg"
                            alt="LA"
                          />
                        </div>
                        <div className="score-content">   
                          <div className="score-user-info">
                            <img
                              className="score-user-img img-fluid"
                              src="/images/web-new-images/icons/user-icon.png"
                              alt="LA"
                            />
                            <h3 className="score-user-name">Varun D.</h3>
                          </div>                   
                          <p className="normal-text">"Varun Dhawan's guidance was instrumental in my PTE success. His course is a must-have for serious test-takers."</p>                        
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="score-slider-card">
                        <div className="img-wrapper">
                          <img
                            className="img-fluid"
                            src="/images/web-new-images/pte3.jpeg"
                            alt="LA"
                          />
                        </div>
                        <div className="score-content">   
                          <div className="score-user-info">
                            <img
                              className="score-user-img img-fluid"
                              src="/images/web-new-images/icons/user-icon.png"
                              alt="LA"
                            />
                            <h3 className="score-user-name">Varun D.</h3>
                          </div>                   
                          <p className="normal-text">"Varun Dhawan's guidance was instrumental in my PTE success. His course is a must-have for serious test-takers."</p>                        
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="score-slider-card">
                        <div className="img-wrapper">
                          <img
                            className="img-fluid"
                            src="/images/web-new-images/pte3.jpeg"
                            alt="LA"
                          />
                        </div>
                        <div className="score-content">   
                          <div className="score-user-info">
                            <img
                              className="score-user-img img-fluid"
                              src="/images/web-new-images/icons/user-icon.png"
                              alt="LA"
                            />
                            <h3 className="score-user-name">Varun D.</h3>
                          </div>                   
                          <p className="normal-text">"Varun Dhawan's guidance was instrumental in my PTE success. His course is a must-have for serious test-takers."</p>                        
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="score-slider-card">
                        <div className="img-wrapper">
                          <img
                            className="img-fluid"
                            src="/images/web-new-images/pte3.jpeg"
                            alt="LA"
                          />
                        </div>
                        <div className="score-content">   
                          <div className="score-user-info">
                            <img
                              className="score-user-img img-fluid"
                              src="/images/web-new-images/icons/user-icon.png"
                              alt="LA"
                            />
                            <h3 className="score-user-name">Varun D.</h3>
                          </div>                   
                          <p className="normal-text">"Varun Dhawan's guidance was instrumental in my PTE success. His course is a must-have for serious test-takers."</p>                        
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="score-slider-card">
                        <div className="img-wrapper">
                          <img
                            className="img-fluid"
                            src="/images/web-new-images/pte3.jpeg"
                            alt="LA"
                          />
                        </div>
                        <div className="score-content">   
                          <div className="score-user-info">
                            <img
                              className="score-user-img img-fluid"
                              src="/images/web-new-images/icons/user-icon.png"
                              alt="LA"
                            />
                            <h3 className="score-user-name">Varun D.</h3>
                          </div>                   
                          <p className="normal-text">"Varun Dhawan's guidance was instrumental in my PTE success. His course is a must-have for serious test-takers."</p>                        
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="score-slider-card">
                        <div className="img-wrapper">
                          <img
                            className="img-fluid"
                            src="/images/web-new-images/pte3.jpeg"
                            alt="LA"
                          />
                        </div>
                        <div className="score-content">   
                          <div className="score-user-info">
                            <img
                              className="score-user-img img-fluid"
                              src="/images/web-new-images/icons/user-icon.png"
                              alt="LA"
                            />
                            <h3 className="score-user-name">Varun D.</h3>
                          </div>                   
                          <p className="normal-text">"Varun Dhawan's guidance was instrumental in my PTE success. His course is a must-have for serious test-takers."</p>                        
                        </div>
                      </div>
                    </div>
                    </Slider>
                  </div>             
            </div>
          </div>
          <div className="goals-section why-video-course pc-support-section">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center">
              Why Choose <br className="d-block" /><span className="wpl-badge pte-naati-badge">Our Video Course?</span>             
              </h2>
            </div>
            <div className="single-language-card">
              <div className="language-cards position-relative">              
                <img
                  className="emoji-icon2"
                  src="/images/web-new-images/emojis/emoji-1.png"
                  alt="LA"
                />
                <div className="position-relative">
                  <img
                    className="emoji-img"
                    src="/images/web-new-images/emojis/emoji-4.png"
                    alt="LA"
                  />
                  <div className="language-card">
                    <ul className="p-0 m-0">
                      <li className="tick-list-item">
                        <h3>
                          <img
                            src="/images/web-new-images/icons/check-icon-01.svg"
                            alt="LA"
                          />{" "}
                           Expert Instruction
                        </h3>
                        <p>
                        Benefit from Varun Dhawan's extensive teaching experience spanning over 6 years and his unparalleled success in guiding 50,000+ students to PTE success.
                        </p>
                      </li>
                      <li className="tick-list-item">
                        <h3>
                          <img
                            src="/images/web-new-images/icons/check-icon-01.svg"
                            alt="LA"
                          />{" "}
                          Proven Strategies
                        </h3>
                        <p>
                        Learn Varun's tried-and-tested tips and tricks guaranteed to enhance your performance in the exam.
                        </p>
                      </li>
                      <li className="tick-list-item">
                        <h3>
                          <img
                            src="/images/web-new-images/icons/check-icon-01.svg"
                            alt="LA"
                          />{" "}
                          Comprehensive Coverage
                        </h3>
                        <p>
                        Access detailed video tutorials covering every aspect of the PTE tasks.
                        </p>
                      </li>
                      <li className="tick-list-item">
                        <h3>
                          <img
                            src="/images/web-new-images/icons/check-icon-01.svg"
                            alt="LA"
                          />{" "}
                          Exclusive Access
                        </h3>
                        <p>
                        Available only with our Gold package, ensuring you receive the highest quality instruction.
                        </p>
                      </li>
                    </ul>
                    <div className="text-center">                   
                    <Link to="/auth/register" className="primary-btn light-border">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" /></Link>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div className="feature-section included-section p-0">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center">
              What's Included
              </h2>
              <div className="position-relative">
                {/* <img
                  className="emoji-img"
                  src="/images/web-new-images/emojis/44.png"
                  alt="LA"
                /> */}
                <div className="feature-cards">
                    <div className="feature-card blue-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/feature-01.svg"
                          alt="LA"
                        />
                      </div>
                      <h3>Detailed Task Insights</h3>
                      <p>
                      Dive deep into each PTE task with comprehensive video modules.
                      </p>
                    </div>
                    <div className="feature-card light-apricot-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/feature-022.svg"
                          alt="LA"
                        />
                      </div>
                      <h3>Exam Strategies</h3>
                      <p>
                      Master effective strategies tailored to each section of the exam.
                      </p>
                    </div>
                    <div className="feature-card mint-green-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/feature-055.svg"
                          alt="LA"
                        />
                      </div>
                      <h3>Varun Dhawan's Expertise</h3>
                      <p>
                      Learn from Varun's personal insights and strategies that have consistently delivered outstanding results.
                      </p>
                    </div>
                </div>
              </div>
              <div className="text-center">
                <a href="/auth/register" className="primary-btn dark-border">
                Upgrade to Gold Package and Access Video Course <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                </a>
              </div>
            </div>
          </div>
          </div>
          <div className="journey-section">
            <div className="container">                       
                <div className="row align-items-center">
                    <div className="col-lg-5">
                    <h2 className="primary-heading">Start Your <br className="d-none d-md-block" />  Journey <br className="d-none d-md-block" /><span className="wpl-badge text-white">PTE Success Today</span></h2>                        
                    </div>
                    <div className="col-lg-7">
                      <div className="upgrade-content">
                        <h3>UPGRADE TO OUR <span className="gold-btn">GOLD PACKAGE</span></h3>
                        <p>to unlock Varun Dhawan's acclaimed video course and take your PTE preparation to the next level.</p>
                      </div>
                      <div className="gradient-box">
                        <div className="upgrade-card">
                          <h3>Achieve your dream PTE score with confidence.</h3>
                          <a href="/auth/register" className="primary-btn dark-border">Upgrade to Gold Package and Access Video Course <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" /></a>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                    <div className="video-wrapper">
                      <iframe
                        src="https://player.vimeo.com/video/984725169?h=e48ced1845&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                        frameBorder="0"
                        width="100%"
                        allow="fullscreen;"
                        allowFullScreen
                      ></iframe>
                    </div>
                    </div>                
                </div> 
              </div>
          </div>        
          <VideoTestimonial /> 
          <div className="faq-section">
          <div className="container">
            <div className="row">
              <h2 className="secondary-heading text-center">
                Frequently Asked Questions
              </h2>

              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      What is the recommended number of PTE mock tests that I
                      should undertake?
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      It is recommended to take three complete PTE mock tests.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      What is the PTE requirement for canada?
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      It is recommended to take three complete PTE mock tests.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      What is the duration of a full-length PTE mock test?
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      It is recommended to take three complete PTE mock tests.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}
export default VideoCourse;
